export const lightModePalette = {
    mode: "light",
    background: {
      default: "white",
    },
  };
